import { render } from "./git-like-document-history.vue?vue&type=template&id=a1af7a70&ts=true&lang=html"
import script from "./git-like-document-history.vue?vue&type=script&lang=ts"
export * from "./git-like-document-history.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__